<template>
    <div  :style='{width: panelWidth}' >
    <el-table
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.label)'
    >
      <!-- <el-table-column :label="$t(label)" sortable prop='label' align="left" /> -->
      <el-table-column :label="$t('symbol')" sortable prop='label' align="left" />
      <el-table-column :label="$t('Swap Long')" sortable prop='financingLong' :sort-method='(a,b) => sortFloat(a,b,"financingLong")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.financingLong >= 0  ? "positive" : "negative"'>{{ scope.row.financingLong | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Swap Short')" sortable prop='financingShort' :sort-method='(a,b) => sortFloat(a,b,"financingShort")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.financingShort >= 0  ? "positive" : "negative"'>{{ scope.row.financingShort | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Net Swap')" sortable prop='rollOver' :sort-method='(a,b) => sortFloat(a,b,"rollOver")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.rollOver >= 0  ? "positive" : "negative"'>{{ scope.row.rollOver | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Commission')" sortable prop='commission' :sort-method='(a,b) => sortFloat(a,b,"commission")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.commission >= 0  ? "positive" : "negative"'>{{ scope.row.commission | formatAmount }}</div>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
//import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import utils from '@/utils/formatNumber'
// import { mapState } from 'vuex'
import monitoringMixin from './mixins'

export default {
  name: 'FlowArray',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  //components: {LuScrollArea, LuHbox, LuVbox, LuItem},
  computed: {
    //...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping }),
    isSymbolGrpKey: function () {
      //return this.groupKeys[this.panel.options.groupKey] === "symbol"
      return true
    }
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatRate: function (value, prec) {
      return utils.formatNumber(value || 0, prec)
    }
  },
  methods: {
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'Symbol' : 'Currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]

      if (label === 'Total') return //not an instrument

      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: 'flow', value: label, params: params, show: true})
    }
  }
}
</script>

<style lang='scss' scoped>
.inst-container {
  .rowData {
    justify-content: center;
    vertical-align: baseline;
    height: 25px;
    margin: 5px 0;
  }
}
</style>